import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14.75,8a.72.72,0,0,1-.06.29.85.85,0,0,1-.17.25L9.1,13.76a.76.76,0,0,1-1.06,0,.76.76,0,0,1,0-1.07l4.08-3.93H2a.75.75,0,0,1,0-1.5H12.14L8.06,3.31a.75.75,0,1,1,1-1.08l5.42,5.23a.74.74,0,0,1,.17.25A.72.72,0,0,1,14.75,8Z';
const draw24px =
  'M21.17,12a.73.73,0,0,1-.23.54l-5.42,5.23A.77.77,0,0,1,15,18a.7.7,0,0,1-.54-.23.75.75,0,0,1,0-1.06l4.08-3.94H4a.75.75,0,0,1,0-1.5H18.56L14.48,7.32a.75.75,0,0,1,1-1.08l5.42,5.22A.76.76,0,0,1,21.17,12Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ArrowRightIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'arrowRight'),
) as IconWithRender;

ArrowRightIcon.displayName = 'ArrowRightIcon';
ArrowRightIcon.propTypes = Icon.propTypes;
ArrowRightIcon.renderIcon = (props) => <ArrowRightIcon {...props} />;
export default ArrowRightIcon;
